import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAlert } from "../../../context/AlertContext";
import { useLoading } from "../../../context/LoadingContext";
import {
  formatDate,
  formatDateTime,
  formatSplitKey
} from "../../../commons/FormatValue";
import { FormCheckComponent, FormControlComponent } from "../../FormComponent";
import { Button, Card, Col, Row } from "react-bootstrap";
import CardDisplayComponent from "../../CardDisplayComponent";
import PrintButton from "../../PrintButton";
import ReportHeadComponent from "../../ReportHeadComponent";
import Table from "../../Table";
import InformInstallItemBomsService from "../../../services/informinstallitembom.service";
import { getServiceRequest } from "../../../commons/ServiceRequest";
import { filteredItemInArray } from "../../../utils/ManageArray";
import PaginationComponent from "../../PaginationComponent";
import { useAuth } from "../../../context/AuthContext";

const PreviewInstallForm = () => {
  const navigate = useNavigate();
  const canvasRef = useRef(null);
  const { user } = useAuth();
  const { state } = useLocation();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const [Branch, setBranch] = useState({});
  const [CustContractItems, setCustContractItems] = useState([]);
  const Install = state?.data?.Install || state?.row || [];
  const [ItemBoms, setItemBoms] = useState(state?.data?.ItemBoms || []);
  const [currentPage, setCurrentPage] = useState(1);
  const currentDate = formatDateTime(new Date().toISOString());
  const InstallItem =
    state?.data?.Install.length > 0
      ? state?.data?.Install.map((item) => ({
          ...state?.data?.Install,
          Item: item,
          Printed_By: user?.username,
          Printed_Date_Time: currentDate
        }))
      : [
          {
            ...state?.data?.Install,
            Item: null,
            Printed_By: user?.username,
            Printed_Date_Time: currentDate
          }
        ];
  const currentData = InstallItem[0]?.InformInstallItem?.[currentPage - 1];
  const Address = InstallItem[0]?.Customer;
  const inputField = {
    Install: [
      {
        name: "Install_Doc_No",
        label: "หมายเลขแจ้งงานติดตั้ง",
        className: { col: "mb-3", input: "mb-1" },
        size: 12
      }
    ],
    Install1: [
      {
        name: "Inform_By",
        label: "ผู้แจ้ง",
        className: { col: "mb-3", input: "mb-1" },
        size: "2_5"
      },
      {
        name: "Inform_Section",
        label: "แผนกที่แจ้ง",
        className: { col: "mb-3", input: "mb-1" },
        size: 2
      },
      {
        name: "Project_No",
        label: "หมายเลขโครงการ",
        className: { col: "mb-3", input: "mb-1" },
        size: 2
      },
      {
        name: "Service_Call",
        label: "Call No.",
        className: { col: "mb-3", input: "mb-1" },
        size: 2
      },
      { name: "", className: { col: "mb-3", input: "mb-1" }, size: null },
      ,
      {
        name: "Job_Cus_Date",
        label: "วันที่นัดหมายลูกค้า",
        format: (row) => formatDate(row)
      },

      {
        name: "Customer.Cus_Code",
        label: "รหัสลูกค้าหลัก (BP Master Code)",
        className: { col: "mb-3", input: "mb-1" },
        size: "2_5"
      },
      {
        name: "Customer.Cus_Name",
        label: "ชื่อลูกค้า",
        className: { col: "mb-3", input: "mb-1" },
        size: 6
      },
      { name: "", className: { col: "mb-3", input: "mb-1" }, size: null },

      {
        name: "Cus_Contract_Name1",
        label: "ผู้ติดต่อ 1",
        className: { col: "mb-3", input: "mb-1" }
      },
      {
        name: "Customer.Cus_Address",
        label: "ที่อยู่",
        size: "8_5",
        className: { col: "mb-3", label: "mb-1" },
        as: "textarea",
        rows: 3,
        plusString: `${
          Address?.Cus_Address +
            " " +
            Address?.Cus_Road +
            " " +
            Address?.Cus_District +
            " " +
            Address?.Cus_SubDistrict +
            " " +
            Address?.Cus_Province +
            " " +
            Address?.Cus_ZipCode || " "
        }`
      },
      { name: "", className: { col: "mb-3", input: "mb-1" }, size: null },
      {
        name: "Cus_Contract_Name2",
        label: "ผู้ติดต่อ 2",
        className: { col: "mb-3", input: "mb-1" }
      },
      {
        name: "BPCustomer.Cus_Code",
        label: "รหัสสาขา",
        className: { col: "mb-3", input: "mb-1" },
        size: "2_5"
      },
      {
        name: "BPCustomer.Cus_NumBranch",
        label: "เลขที่สาขา",
        className: { col: "mb-3", input: "mb-1" },
        size: 2
      },
      {
        name: "BPCustomer.Cus_Name",
        label: "ชื่อลูกค้า/สาขา",
        className: { col: "mb-3", input: "mb-1" },
        size: 4
      },
      { name: "", className: { col: "mb-3", input: "mb-1" }, size: null },
      {
        name: "Cus_Contract_Tel1",
        label: "เบอร์โทรผู้ติดต่อ 1",
        className: { col: "mb-3", input: "mb-1" }
      },

      {
        name: "Customer.Cus_Address",
        label: "สถานที่จัดส่งสินค้า",
        className: { col: "mb-3", input: "mb-1" },
        size: "8_5"
      },
      { name: "", className: { col: "mb-3", input: "mb-1" }, size: null },
      {
        name: "Cus_Contract_Tel2",
        label: "เบอร์โทรผู้ติดต่อ 2",
        className: { col: "mb-3", input: "mb-1" },
        size: 3
      },
      { name: "GoogleMap_Link", label: "Google Map", size: "8_5" },
      { name: "", className: { col: "mb-3", input: "mb-1" }, size: null },
      { name: "Customer.Cus_ContactEmail", label: "Email", size: 3 }
    ],
    Install2: [
      {
        name: "Cus_Spec_Tex",
        label: "คำสั่งเพิ่มเติม (ลูกค้า)",
        as: "textarea",
        rows: 10,
        size: 12
      }
    ],
    Radio: [
      { name: "PM_List", label: "มี PM" },
      { name: "PM_List", label: "ไม่มี PM" },
      { name: "PM_List", label: "รอสรุป" }
    ],
    Maintenance: [
      {
        name: "Contract_No",
        label: "เลขที่สัญญา",
        cclassName: { col: "mb-3", input: "mb-1" },
        size: 4
      },
      {
        name: "CustContract.Contract_Start_Date",
        label: "วันที่เริ่มต้นสัญญา",
        className: { col: "mb-3", input: "mb-1" },
        size: 4
      },
      {
        name: "CustContract.Contract_End_Date",
        label: "วันที่สิ้นสุดสัญญา",
        className: { col: "mb-3", input: "mb-1" },
        size: 4
      },
      {
        name: "CustContract.CustContractItem.0.PM_Per_Year",
        label: "จำนวน PM/ปี",
        className: { col: "mb-3", input: "mb-1" },
        size: 4
      },
      {
        name: "Employee_Id",
        label: "ผู้แจ้ง",
        size: 4,
        classNames: { col: "mb-3", input: "mb-1" },
        plusString: `${InstallItem?.[0]?.Employee?.Employee_Name} ${InstallItem?.[0]?.Employee?.Employee_Surname}`
      },
      {
        name: "Inform_Section",
        label: "แผนกที่แจ้ง",
        className: { col: "mb-3", input: "mb-1" },
        size: 4
      }
    ],
    Checkbox: [
      { name: "Job_List1", label: "สำรวจหน้างาน" },
      { name: "Job_List2", label: "งานรื้อถอน" },
      { name: "Job_List3", label: "ติดตั้ง" },
      { name: "Job_List4", label: "เทสระบบ" },
      { name: "Job_List5", label: "Training/ส่งมอบ" },
      { name: "Job_List6", label: "เก็บน้ำ" }
    ],
    Check: [
      { name: "", className: { col: "mb-3", input: "mb-1" }, size: null },
      { name: "Check_1", label: "ผู้ตรวจสอบ", size: 5 },
      { name: "", className: { col: "mb-3", input: "mb-1" }, size: null }
    ],
    Check2: [
      { name: "", className: { col: "mb-3", input: "mb-1" }, size: null },
      { name: "Check_2", label: "ผู้อนุมัติ", size: 5 },
      { name: "", className: { col: "mb-3", input: "mb-1" }, size: null }
    ]
  };

  const columns = {
    InstallItem: [
      { name: "ลำดับ", selector: (row) => row?.rowIndex },
      { name: "รหัสสินค้า", selector: (row) => row?.Item?.Item_Code },
      { name: "รหัสทรัพย์สิน", selector: (row) => row?.Asset_Code },
      { name: "รายละเอียดสินค้า", selector: (row) => row?.Item?.Item_Name_TH },
      {
        name: "หมายเลขเครื่อง (Serial No.)",
        selector: (row) => row?.Item?.Item_PartNo
      },
      { name: "จำนวน", selector: (row) => row?.Item_Install_Qty },
      { name: "หน่วย", selector: (row) => row?.Uom_Unit },
      { name: "สถานะทรัพย์สิน", selector: (row) => row?.Asset_Status }
    ],
    AssetItem: [
      { name: "ลำดับ", selector: (row) => row?.rowIndex },
      { name: "รหัสสินค้า", selector: (row) => row?.Item?.Item_Code },
      { name: "รหัสทรัพย์สิน", selector: (row) => row?.AssetItem?.Asset_Code },
      {
        name: "รายละเอียดสินค้า",
        selector: (row) => row?.AssetItem?.Asset_Name
      },
      {
        name: "หมายเลขเครื่อง (Serial No.)",
        selector: (row) => row?.Item_PartNo
      },
      { name: "จำนวน", selector: (row) => row?.Item_Install_Qty },
      { name: "หน่วย", selector: (row) => row?.Uom_Unit },
      { name: "สถานะทรัพย์สิน", selector: (row) => row?.Asset_Status }
    ],
    ItemBom: [
      { name: "ลำดับ", selector: (row) => row?.rowIndex },
      { name: "รหัสอุปกรณ์", selector: (row) => row?.ItemChild.Item_Code },
      {
        name: "รายละเอียดอุปกรณ์/อะไหล่",
        selector: (row) => row?.ItemChild.Item_Name_TH
      },
      { name: "จำนวน", selector: (row) => row?.Item_Qty },
      { name: "หน่วย", selector: (row) => row?.Uom_Unit },
      { name: "ราคา", selector: (row) => row?.Price_Per_Unit },
      { name: "ราคารวม", selector: (row) => row?.Amount },
      { name: "หน่วย", selector: (row) => row?.Amount_Unit }
    ],
    ServicePrice: [
      { name: "ลำดับ", selector: (row) => row?.rowIndex },
      { name: "รายการค่าบริการ", selector: (row) => row?.Service_Des },
      { name: "ราคา", selector: (row) => row?.Service_Price },
      { name: "สกุลเงิน", selector: (row) => row?.Service_Unit },
      { name: "หมายเหตุ", selector: (row) => row?.Remark }
    ]
  };

  const showData = (field) => {
    return field?.map(
      (
        {
          name,
          label,
          size,
          className,
          as,
          rows,
          format,
          plusString,
          findValue
        },
        idx
      ) => {
        const joinData = formatSplitKey(name, ".", InstallItem[0]);

        const result =
          (name === "Seq_Oth_No" && Seq?.[name]) ||
          (findValue && Branch?.[findValue?.value]) ||
          (findValue && CustContractItems?.[findValue?.value]) ||
          (plusString && plusString) ||
          (format && format(joinData)) ||
          joinData ||
          "";

        return (
          <Col
            key={idx}
            sm={size ? size : size === null ? null : 3}
            className={`${className?.col}`}
          >
            {name && (
              <FormControlComponent
                readOnly
                as={as}
                rows={rows}
                type="text"
                name={name}
                label={label}
                className={{
                  ...className,
                  label: `w-100 text-truncate ${className?.label}`
                }}
                value={result}
              />
            )}
          </Col>
        );
      }
    );
  };

  useEffect(() => {
    if (state?.row) {
      getServiceRequest({
        showAlert,
        setLoading,
        serviceRequest:
          InformInstallItemBomsService.getAllInformInstallItemBoms(),
        callback: (res) =>
          setItemBoms(
            filteredItemInArray(
              res,
              "InformInstallItem.Job_Install_Id",
              state?.row?.Id
            )
          )
      });
    }
  }, [currentData]);

  return (
    <>
      <CardDisplayComponent
        cardClassName="position-relative"
        header={{
          title: {
            className: "mb-0 fs-2 text-center",
            text: "แสดงและพิมพ์ใบแจ้งงานติดตั้ง"
          },
          button: <PrintButton componentRef={canvasRef} />
        }}
        body={{
          ref: canvasRef,
          element: (
            <>
              <CardDisplayComponent
                cardBorder={1}
                header={{
                  title: {
                    className: "mb-0 fs-2 text-center",
                    text: `ใบแจ้งงานติดตั้ง : ${InstallItem[0]?.JobTypeSub?.Job_Type_Sub_Name}`
                  }
                }}
                body={{
                  as: Row,
                  element: (
                    <>
                      <Col
                        sm={9}
                        className="ReportHead mb-3 d-flex align-items-center"
                      >
                        <ReportHeadComponent formName="Installation notification form" />
                      </Col>
                      <Col as={Row} sm={3} className="mx-0 px-0">
                        {showData(inputField.Install)}
                      </Col>
                      <Col as={Row} sm={12} className="mx-0 px-0">
                        {showData(inputField.Install1)}
                      </Col>
                    </>
                  )
                }}
              />
              <CardDisplayComponent
                cardBorder={1}
                header={{
                  title: {
                    className: "mb-0 fs-2 ",
                    text: `รายการสินค้า`
                  }
                }}
                body={{
                  element: (
                    <>
                      <Table
                        data={[currentData]}
                        column={
                          Install?.InformInstallItem?.[0]?.AssetItem
                            ? columns?.AssetItem
                            : columns?.InstallItem
                        }
                      />
                    </>
                  )
                }}
              />

              {!Install?.InformInstallItem?.[0]?.Asset_Code && (
                <CardDisplayComponent
                  cardBorder={1}
                  header={{
                    title: {
                      className: "mb-0 fs-2 ",
                      text: `รายการอะไหล่/อุปกรณ์`
                    }
                  }}
                  body={{
                    element: (
                      <Table
                        data={filteredItemInArray(ItemBoms, "Install_Item_Id", [
                          currentData.Id
                        ])}
                        column={columns.ItemBom}
                      />
                    )
                  }}
                />
              )}

              <CardDisplayComponent
                cardBorder={1}
                header={{
                  title: {
                    className: "mb-0 fs-2 ",
                    text: `รายละเอียดค่าบริการ`
                  }
                }}
                body={{
                  element: (
                    <Table
                      data={Install?.InstallServicePrice}
                      column={columns.ServicePrice}
                    />
                  )
                }}
              />

              <CardDisplayComponent
                cardBorder={1}
                cardClassName="mb-1"
                body={{
                  as: Row,
                  element: (
                    <>
                      <Col sm={5}>{showData(inputField.Install2)}</Col>
                      <Col sm={4}>
                        <Card.Title className="mb-0 py-2 text-center bg-info fs-3">
                          Preventive Maintenance
                        </Card.Title>
                        <Row className="justify-content-center">
                          {inputField.Radio.map(({ name, label }, idx) => (
                            <Col key={idx} sm={1} className="mb-3 w-auto">
                              <FormCheckComponent
                                readOnly
                                key={idx}
                                name="list"
                                label={label}
                                type="radio"
                                className={{ check: "py-3" }}
                                checked={Install?.[name] === label}
                              />
                            </Col>
                          ))}
                        </Row>
                        <Row>{showData(inputField.Maintenance)}</Row>
                      </Col>
                      <Col sm={3}>
                        <Card.Title className="mb-0 py-2 text-center fs-3">
                          รายละเอียดการทำงาน
                        </Card.Title>
                        <Row className="justify-content-center">
                          {inputField.Checkbox.map(({ name, label }, idx) => (
                            <FormCheckComponent
                              key={idx}
                              name="list"
                              label={label}
                              type="checkbox"
                              className={{ check: "py-2 p-5" }}
                              checked={Install?.[name] === label}
                              readOnly
                            />
                          ))}
                        </Row>
                      </Col>
                    </>
                  )
                }}
              />

              <CardDisplayComponent
                cardBorder={1}
                body={{
                  element: (
                    <Row>
                      <Col as={Row} sm={6} className="mx-0 px-0">
                        {showData(inputField.Check)}
                      </Col>
                      <Col as={Row} sm={6} className="mx-0 px-0">
                        {showData(inputField.Check2)}
                      </Col>
                    </Row>
                  )
                }}
              />
            </>
          )
        }}
      />

      <CardDisplayComponent
        footer={{
          className: "text-center",
          element: (
            <>
              <PaginationComponent
                data={InstallItem[0]?.InformInstallItem}
                currentPage={currentPage}
                itemsPerPage={1}
                onPageChange={(newPage) => setCurrentPage(newPage)}
              />
              <Button
                variant="outline-secondary"
                className="px-4 py-2 text-dark rounded-pill"
                onClick={() =>
                  navigate("/installation_work/record", {
                    state: {
                      data: state?.data,
                      name: "data",
                      searchValue: state?.searchValue,
                      Employee: state?.Employee
                    }
                  })
                }
              >
                ย้อนกลับ
              </Button>
            </>
          )
        }}
      />
    </>
  );
};
export default PreviewInstallForm;
